"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProCon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _offerStyles = require("../loan-card-v3/offer-styles");

var _jsxRuntime = require("react/jsx-runtime");

var StyledWithIconWrapper = (0, _styledComponents["default"])(_offerStyles.WithIconWrapper).withConfig({
  displayName: "StyledWithIconWrapper",
  componentId: "sc-ckfpk5-0"
})(["margin-top:24px;"]);

var ProCon = function ProCon(_ref) {
  var _navEditorial$cons;

  var navEditorial = _ref.navEditorial;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(navEditorial === null || navEditorial === void 0 ? void 0 : navEditorial.pros) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWithIconWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
        name: "actions/circle-plus",
        color: _baseReactComponents.theme.seaturtleGreen200
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          bold: true,
          children: "Pros"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          children: navEditorial.pros
        })]
      })]
    }), (navEditorial === null || navEditorial === void 0 ? void 0 : navEditorial.cons) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWithIconWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
        name: "actions/circle-minus",
        color: _baseReactComponents.theme.sebastianRed200
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          bold: true,
          children: "Cons"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          children: (_navEditorial$cons = navEditorial === null || navEditorial === void 0 ? void 0 : navEditorial.cons) !== null && _navEditorial$cons !== void 0 ? _navEditorial$cons : ''
        })]
      })]
    })]
  });
};

exports.ProCon = ProCon;
//# sourceMappingURL=pro-con.js.map